module.exports = __webpack_public_path__ + "static/media/puzzle-piece.e19e94b7.svg";